// extracted by mini-css-extract-plugin
export default {"wrapper":"WaveForm_wrapper__XNgd6","input":"WaveForm_input__z2e34","input__label":"WaveForm_input__label__jiF81","actions":"WaveForm_actions__Ys4Tz"};